module.exports = __webpack_public_path__ + "media/images/icon__calendar@3x-58a9570e8b88f019c596495641a08982.png";